module.exports = __webpack_public_path__ + "static/media/pahanggo_main_logo.a7301bfa.png";